'use strict';

DoohApps
    .service('campaignBLL', ['Campaign', 'CampaignSchedule', 'CampaignDataFilter', 'PersonsData', 'ConfiguratorBlock', '$q', '$http', 'Voucher', 'ScreensData', 'AppStoreData', 'RepeatData', '$timeout', 'MediaDevicesData', 'DoohHelper', 'ConfigurationBlockHelper',
        function (Campaign, CampaignSchedule, CampaignDataFilter, PersonsData, ConfiguratorBlock, $q, $http, Voucher, ScreensData, AppStoreData, RepeatData, $timeout, MediaDevicesData, DoohHelper, ConfigBlockHelper) {
            var _this = this;
            _this.Campaign = {};

            this.GetAppInboxList = function (callback, objectFilterOptions) {
                Campaign.getCampaignList(function (data) { callback(data); }, objectFilterOptions);
            }

            this.GetLatestApps = function (callback, QuickApp) {
                Campaign.getLatestApps(function (data) { callback(data); }, QuickApp);
            }

            this.GetCampaignAssetFiles = function (callback, objParam) {
                Campaign.getCampaignAssetFiles(function (data) { callback(data) }, objParam);
            }

            this.RateYourApplication = function (callback, rate) {
                Campaign.rateYourApplication(function (data) { callback(data); }, rate);
            }

            this.GetApplicationsByScreen = function (callback, filter) {
                ScreensData.getApplicationsForScreen(function (data) { callback(data.Data.Content); }, filter);
            }

            this.deleteCampaignSchedule = function (callback, deleteSchedule) {
                CampaignSchedule.deleteCampaignSchedule(function (data) { responseHandler(callback, data); }, deleteSchedule);
            }

            this.VoucherList = function (callback, applicationId, mediaId, groupID, expiredDate, IssuedDate) {
                Voucher.getVoucherList(function (data) { callback(data.Data.Content) }, applicationId, mediaId, groupID, expiredDate, IssuedDate);
            }

            this.GetLicenses = function (callback, ApplicationID, mediaID) {
                Voucher.getLicenses(function (data) { callback(data.Data.Content) }, ApplicationID, mediaID);
            }

            this.GetLicensesList = function (callback, ApplicationID) {
                Voucher.getLicensesList(function (data) { callback(data.Data.Content) }, ApplicationID);
            }

            this.UpdateScheduleAppointment = function (callback, appointment) {
                CampaignSchedule.updateCampaignSchedule(function (data) { callback(data); }, appointment)
            }

            this.ScheduleCampaignScreen = function (callback, campaignSchedule) {
                CampaignSchedule.addCampaignSchedule(function (data) { callback(data); }, campaignSchedule);
            }

            this.updateCampaign = function (callback, campaign) {
                Campaign.updateCampaign(function (data) { responseHandler(callback, data) }, campaign);
            }

            this.saveConfiguration = function (callback, campaign) {
                campaign.CampaignTitle = campaign.TitleCopy;

                var blockType = ConfigBlockHelper.configurationBlockType;

                angular.forEach(campaign.ConfigBlocks, function (blockVal, key) {
                    angular.forEach(campaign.AppConfigurations, function (configVal, key2) {
                        if (blockVal.BlockID == configVal.BlockID) {
                            switch (blockVal.BlockName) {
                                case blockType.singleSelect:
                                case blockType.languageSelect:
                                    configVal.ConfigurationValue = [];
                                    angular.forEach(blockVal.Options, function (v, k) {
                                        if (v.ticked == true)
                                            configVal.ConfigurationValue.push(
                                                v.res
                                            );
                                    });

                                    configVal.ConfigurationValue = JSON.stringify(configVal.ConfigurationValue);
                                    break;
                                case blockType.colorVideoImagePicker:
                                    if (blockVal.ConfigurationValue == undefined)
                                        blockVal.ConfigurationValue = {};

                                    if (blockVal.ConfigurationValue.Active == undefined) {
                                        if (blockVal.Options[0].color == true && blockVal.Options[0].image == false && blockVal.Options[0].video == false) blockVal.ConfigurationValue.Active = 'Col';
                                        if (blockVal.Options[0].color == false && blockVal.Options[0].image == true && blockVal.Options[0].video == false) blockVal.ConfigurationValue.Active = 'Img';
                                        if (blockVal.Options[0].color == false && blockVal.Options[0].image == false && blockVal.Options[0].video == true) blockVal.ConfigurationValue.Active = 'Vid';
                                    }

                                    if ((blockVal.ConfigurationValue.Active == undefined && blockVal.Options[0].color == true) || blockVal.ConfigurationValue.Active == 'Col') {
                                        blockVal.ConfigurationValue.Active = 'Col'
                                        delete blockVal.ConfigurationValue.Image;
                                        delete blockVal.ConfigurationValue.Video;
                                        configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue);
                                    }
                                    if ((blockVal.ConfigurationValue.Active == undefined && blockVal.Options[0].color == false && blockVal.Options[0].image == true) || blockVal.ConfigurationValue.Active == 'Img') {
                                        blockVal.ConfigurationValue.Active = 'Img'
                                        delete blockVal.ConfigurationValue.Color;
                                        delete blockVal.ConfigurationValue.Video;
                                        configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue);
                                    }
                                    if (blockVal.ConfigurationValue.Active == 'Vid') {
                                        blockVal.ConfigurationValue.Active = 'Vid'
                                        delete blockVal.ConfigurationValue.Image;
                                        delete blockVal.ConfigurationValue.Color;
                                        configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue);
                                    }
                                    break;
                                case blockType.colVidImgPickerWithAttachments:
                                    configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue);
                                    break;
                                case blockType.effectColor:
                                case blockType.checkbox:
                                case blockType.slider:
                                case blockType.textInput:
                                    configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue);
                                    break;
                                case blockType.effectSelect:
                                    configVal.ConfigurationValue = [];
                                    angular.forEach(blockVal.Options, function (v, k) {
                                        if (v.selected == true)
                                            configVal.ConfigurationValue.push(
                                                v.value
                                            );
                                    });

                                    configVal.ConfigurationValue = JSON.stringify(configVal.ConfigurationValue);
                                    break;
                                case blockType.positioning:
                                case blockType.region:
                                    configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue);
                                    break;
                                case blockType.simpleMediaPicker:
                                    configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue);
                                    break;
                                case blockType.jsonEditor:
                                    configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue.value);
                                    break;
                                case blockType.mediaList:
                                    //delete unnecessarry properties. This also saves selected assets state which we don't want
                                    blockVal.ConfigurationValue.forEach(function (asset) {
                                        delete asset.selected;
                                    });
                                    configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue);
                                    break;
                                case blockType.textBlock:
                                    configVal.ConfigurationValue = JSON.stringify(blockVal.ConfigurationValue);
                                    break;
                                default:
                                    configVal.ConfigurationValue = blockVal.ConfigurationValue;
                                    break;
                            }
                        }
                    });
                });

                Campaign.updateCampaignConfiguration(function (data) { callback(data); }, campaign);
            }

            this.LoadConfiguration = function (callback, campaign) {
                var campaignInfoCallback = function (campaignInfoData) {
                    if (campaignInfoData.hasError !== undefined && campaignInfoData.hasError == true
                        || campaignInfoData.error_description !== undefined) {
                        campaignInfoData.error_description = (campaignInfoData.error_description) ? campaignInfoData.error_description : (campaignInfoData.errors.length > 0) ? campaignInfoData.errors[0] : 'an error has occured (campaignInfoCallback), but no specific info has been found';
                        callback(campaignInfoData);
                        return;
                    }
                    void 0;
                    void 0;

                    campaign = campaignInfoData.Data.Content.Campaign != null ? campaignInfoData.Data.Content.Campaign : campaign;

                    if (campaign.CampaignTitle != undefined)
                        campaign.TitleCopy = campaign.CampaignTitle;

                    campaign.AppConfigurations = campaignInfoData.Data.Content.AppConfigs;
                    campaign.ConfigBlocks = campaignInfoData.Data.Content.ConfigBlockData;
                    campaign.LinkedAssets = campaignInfoData.Data.Content.LinkedAssets;

                    CampaignDataFilter.setConfiguratorBlocks(function () {
                        CampaignDataFilter.prepSelectedApplication(campaign);
                        CampaignDataFilter.loadConfiguration(function () {
                            callback(campaign);
                        });
                    });
                } // campaignInfoCallback
                Campaign.getCampaignConfigInfo( campaignInfoCallback,
                                                { campaignID: campaign.CampaignID, appVersionID: campaign.AppVersionID, isExternalCampaign: campaign.IsExternal });
            } // LoadConfiguration

            this.loadAppVersionConfiguration = function (callback, appVersionId) {
                var version = { appVersionID: appVersionId };
                ConfiguratorBlock.getConfiguratorBlocksbyAppVersion(function (data) {
                    version.AppConfigurations = data.Data.Content;
                    CampaignDataFilter.setConfiguratorBlocks(function () {
                        CampaignDataFilter.prepSelectedApplication(version);
                        CampaignDataFilter.loadConfiguration(function () {
                            callback(version);
                        });
                    });
                }, appVersionId);
            };

            this.GetAppMoreInfoData = function (callback, campaign) {
                AppStoreData.getAppById(function (data) { callback(data); }, campaign.ApplicationID);
            }

            this.deleteCampaign = function (callback, campaign) {
                Campaign.deleteCampaign(function (data) { callback(data); }, campaign.CampaignID);
            }

            this.getEvents = function (callback, objectFilterOptions) {
                Campaign.getCampaignEvents(function (data) { callback(data); }, objectFilterOptions);
            }

            this.isRunning = function (callback, camapignId) {
                Campaign.isCampaignRunning(function (data) { callback(data); }, camapignId);
            }

            this.shareConfiguration = function (callback, campaignData) {
                Campaign.shareConfiguration(function (data) { data.Data.Content; }, campaignData);
            }

            this.getConfiguratorBlocks = function (callback, appVer) {
                ConfiguratorBlock.getConfiguratorBlocksbyAppVersion(function (data) { callback(data) }, appVer);
            }

            this.getSchedulerList = function (callback, filterData) {
                CampaignSchedule.getScheduleList(function (data) { responseHandler(callback, data) }, filterData);
            }

            this.getDevices = function (callback, includeGroups) {
                ScreensData.getScreensForSchedule(function (data) { responseHandler(callback, data) }, includeGroups);
            }

            this.getCampaignsForSchedule = function (callback, filter) {
                var deferred = $q.defer();

                CampaignSchedule.getCampaignsForSchedule(function (data) {
                    responseHandler(callback, data);
                    deferred.resolve();
                }, filter);

                return deferred.promise;
            }

            this.getDevicesForScheduling = function (callback, filter) {
                var deferred = $q.defer();
                CampaignSchedule.getDevicesForSchedule(function (data) {
                    responseHandler(callback, data);
                    deferred.resolve();
                }, filter);
                return deferred.promise;
            };

            this.getLicensesForDevices = function (callback, filter) {
                Voucher.getLicensesForDevices(function (data) { responseHandler(callback, data) }, filter);
            };
            this.MakeTransaction = function (callback, paymentData) {
                Voucher.makeTransaction(function (data) { callback(data) }, paymentData);//data.Data.Content
            }

            this.SaveSchedule = function (callback, campaignSchedule) {
                delete campaignSchedule.$id;
                delete campaignSchedule.start;
                delete campaignSchedule.end;
                CampaignSchedule.createCampaignSchedule(function (data) { responseHandler(callback, data); }, campaignSchedule);
            }

            this.duplicateCampaignLocally = function (callback, campaignID) {
                Campaign.duplicateCampaignLocally(function (data) { callback(data) }, campaignID);
            }

            function responseHandler(callback, data) {
                callback({
                    hasError: data.hasError || (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                    error: getErrorMessage(data),
                    message: data.message || (data.Data != undefined ? data.Data.message : null),
                    content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
                });
            }

            function getErrorMessage(data) {
                if (data.hasError)
                    return data.errors[0];

                return data.error_description || data.error || (data.Data != undefined ? data.Data.error : null);
            }

            this.getRepeatPlaceHolders = function (callback, campaignSchedule) {
                CampaignSchedule.getRepeatPlaceHolders(function (data) { responseHandler(callback, data); }, campaignSchedule);
            }

            this.updatePriorities = function (callback, events) {
                CampaignSchedule.updatePriorities(function (data) { responseHandler(callback, data); }, events);
            }

            this.updateScheduleEvAppointment = function (callback, appointment) {
                CampaignSchedule.updateCampaignScheduleEvent(function (data) { responseHandler(callback, data); }, appointment)
            }

            this.getRepeatEnd = function (callback, campaignSchedule) {
                CampaignSchedule.getRepeatEnd(function (data) { responseHandler(callback, data); }, campaignSchedule);
            }

            this.prepareCampaignUpgrade = function (callback, campaignID) {
                Campaign.prepareCampaignUpgrade(function (data) { responseHandler(callback, data); }, campaignID);
            }

            this.doCampaignUpgrade = function (callback, campaignInfo) {
                Campaign.doCampaignUpgrade(function (data) { responseHandler(callback, data); }, campaignInfo);
            }

            this.getCampaignpage = function (callback, campaignID, itemCount) {
                Campaign.getCampaignpage(function (data) { responseHandler(callback, data); }, campaignID, itemCount);
            }

            this.getCustomScript = function (callback, AppVer) {
                Campaign.getCustomScript(function (data) { responseHandler(callback, data); }, AppVer);
            }

            this.getTimeZones = function (callback) {
                PersonsData.getTimeZones(function (data) { responseHandler(callback, data) });
            }

            this.generateCampaignUniqueCode = function (callback, campaignID) {
                Campaign.generateCampaignUniqueCode(callback, campaignID);
            }

            this.extendCampaignCodeDuration = function (callback, campaignID) {
                Campaign.extendCampaignCodeDuration(callback, campaignID);
            }

            this.shareCampaign = function (callback, shareForm) {
                Campaign.shareConfiguration(callback, shareForm);
            }

            this.getEventOverlapInfo = function (callback, campaignSchedule) {
                CampaignSchedule.getEventOverlapInfo(function (data) { responseHandler(callback, data); }, campaignSchedule);
            }

            this.areRepeatEventsWithSamePriority = function (callback, parentId) {
                CampaignSchedule.areRepeatEventsWithSamePriority(function (data) { responseHandler(callback, data); }, { parentId: parentId });
            }
        }]);